export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-minus-circle-41582dd7c78eb1fd1f3bd452757caee0.svg";